import moment from "moment";
import { Button } from "flowbite-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useApplication } from "../contexts/ApplicationContext";

const SubscriptionGate = ({ children }) => {
  const { user } = useApplication();
  const location = useLocation();
  const navigate = useNavigate();

  const company = user?.Company || {};
  const expirationValue =
    company?.planExpirationDate || company?.planExpiration || null;
  const expirationMoment = expirationValue ? moment(expirationValue) : null;
  const isExpired =
    expirationMoment?.isValid() && moment().isAfter(expirationMoment);
  const hasPlan = Boolean(company?.planId);
  const shouldBlockAccess = isExpired && !hasPlan;

  const allowedRoutes = useMemo(
    () => ["/assinatura", "/assinatura/pagamento"],
    []
  );
  const isAllowedRoute = allowedRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  if (!shouldBlockAccess || isAllowedRoute) {
    return children;
  }

  const expirationLabel = expirationMoment
    ? expirationMoment.format("DD/MM/YYYY")
    : "data desconhecida";

  return (
    <>
      {children}
      <div
        className="fixed inset-0 top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-4 bg-black/60 p-6 text-center"
        style={{ zIndex: "1000" }}
      >
        <div className="max-w-xl space-y-3 rounded-3xl border border-white/20 bg-white/90 p-6 shadow-xl shadow-black/40">
          <p className="text-sm uppercase tracking-[0.4em] text-amber-800">
            Acesso bloqueado
          </p>
          <h2 className="text-2xl font-semibold">
            Seu plano expirou em {expirationLabel}
          </h2>
          <p className="text-sm text-slate-600">
            Para continuar usando o sistema, conclua o pagamento.
          </p>
          <div className="flex flex-col gap-3 pt-2 text-sm font-semibold uppercase tracking-[0.3em]">
            <Button
              className="rounded-full px-6 py-3 text-white"
              onClick={() => navigate("/assinatura")}
            >
              Contrate já
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionGate;
